// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"318":"61c8794c","585":"1374c136"}[chunkId] + ".chunk.js";
};